import { decrypt } from "./crypt_.js"
import axios from "axios";

// Add an interceptor to modify the response before it's processed
let interceptorSet = false;

export function setupAxiosInterceptors() {
  if (interceptorSet) 
    return;
  axios.interceptors.response.use(
    (response) => {
      // Modify the response string before it is interpreted as JSON
      if (response.data) {
        response.data = JSON.parse(decrypt(response.data, response.request.responseURL));
      }

      // Return the modified response
      return response;
    },
    (error) => {
      // Handle any errors if necessary
      return Promise.reject(error);
    } 
  );
  interceptorSet = true;
}
